import { stringUtils } from '@festina-life/core'

import { useLayoutContext } from '../../context/layoutContext'
import type { SubTemplateFieldValue } from '../../types/templateModel'

type Props = {
  variant: SubTemplateFieldValue
}

export const SubTemplateFieldValueName = ({ variant }: Props) => {
  const {
    preferences: {
      templates: { isShowingSimplifiedView },
    },
  } = useLayoutContext()

  return (
    <h4 className="m-0 pl-2 font-medium">
      <div className="flex gap-x-2">
        {stringUtils.addUpperCaseWordBreakOpportunity(
          variant.subTemplateIdentifier,
        )}
        {variant.parent?.value && (
          <div className="text-sm font-normal opacity-50">
            {stringUtils.addUpperCaseWordBreakOpportunity(variant.parent.value)}
          </div>
        )}
      </div>
      <div className="text-sm font-normal opacity-50">
        {`${isShowingSimplifiedView ? stringUtils.addUpperCaseWordBreakOpportunity(variant.modelType?.templateTypeName ?? '') : ''}`}
      </div>
    </h4>
  )
}
